module.exports = __webpack_public_path__ + "static/img/background_popups.05dca910.png";